/**
 * Represents parts of Query Panel which can be editable
 */
export var QPEditablePart;
(function (QPEditablePart) {
    QPEditablePart[QPEditablePart["None"] = 0] = "None";
    QPEditablePart[QPEditablePart["Value"] = 1] = "Value";
    QPEditablePart[QPEditablePart["Attribute"] = 2] = "Attribute";
    QPEditablePart[QPEditablePart["Operator"] = 4] = "Operator";
    QPEditablePart[QPEditablePart["Addition"] = 8] = "Addition";
    QPEditablePart[QPEditablePart["Removal"] = 16] = "Removal";
    QPEditablePart[QPEditablePart["All"] = 255] = "All";
    QPEditablePart[QPEditablePart["NoAddition"] = -9] = "NoAddition";
    QPEditablePart[QPEditablePart["NoRemoval"] = -17] = "NoRemoval";
    QPEditablePart[QPEditablePart["FixedConditionList"] = 5] = "FixedConditionList";
})(QPEditablePart || (QPEditablePart = {}));
//# sourceMappingURL=qp_editable_part.js.map